import { DOCUMENT } from '@angular/common';
import { inject, Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ThemeKey } from '../../../whitelabel/theme-key.enum';
import { Theme } from '../../../whitelabel/theme.contract';
import { THEMES } from '../../../whitelabel/themes.constant';
import { RouteCheckerService } from '../../core/services/route-checker.service';
import { UserLocalStorageService } from '../../shared/services/user-local-storage.service';
import { WhitelabelManagerService } from './whitelabel-manager.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private whitelabelManagerService: WhitelabelManagerService = inject(WhitelabelManagerService);

  public theme$ = new BehaviorSubject<ThemeKey>(this.whitelabelManagerService.getDefaultTheme());
  private storageKey = 'currentTheme';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private userLocalStorageService: UserLocalStorageService,
    private routeCheckerService: RouteCheckerService,
  ) {
    if (!this.routeCheckerService.isPublicRoute()) {
      this.switchTheme(this.getCurrentTheme());
    }
  }

  getCurrentTheme(): ThemeKey {
    if (!this.userLocalStorageService.getUserValue(this.storageKey)) {
      this.userLocalStorageService.setUserValue(this.storageKey, this.whitelabelManagerService.getDefaultTheme());
    }

    return this.userLocalStorageService.getUserValue(this.storageKey) as ThemeKey;
  }

  getTheme(id: ThemeKey): Theme {
    const theme = THEMES.find((theme) => theme.id === id);
    if (!theme) {
      throw new Error(`Theme with id "${id}" not found.`);
    }
    return theme;
  }

  switchTheme(themeKey: ThemeKey) {
    this.userLocalStorageService.setUserValue(this.storageKey, themeKey);
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = themeKey + '.css';
      this.theme$.next(themeKey);
    }
  }
}
